import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import { CgGitFork } from "react-icons/cg";
import { AiFillStar } from "react-icons/ai";
import resumePdf from "../Assets/Khushbu_Hajari_Resume.pdf";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky terminal-navbar" : "navbar terminal-navbar"}
    >
      <Container fluid className="px-3 px-md-4 navbar-container">
        {/* Left Section: Brand Logo */}
        <div className="navbar-left-brand">
          <Navbar.Brand href="#home" className="navbar-brand-name">
            {"</>"}khush_portfolio<span className="navbar-cursor">_</span>
          </Navbar.Brand>
        </div>

        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>

        <Navbar.Collapse id="responsive-navbar-nav">
          {/* Center Section: Compact Nav Links */}
          <Nav className="navbar-nav-centered" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link href="#home" onClick={() => updateExpanded(false)}>
                <span className="path-slash">./</span>home
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link href="#about" onClick={() => updateExpanded(false)}>
                <span className="path-slash">./</span>about
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link href="#education" onClick={() => updateExpanded(false)}>
                <span className="path-slash">./</span>education
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link href="#experience" onClick={() => updateExpanded(false)}>
                <span className="path-slash">./</span>experience
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link href="#projects" onClick={() => updateExpanded(false)}>
                <span className="path-slash">./</span>projects
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link href="#hackathons" onClick={() => updateExpanded(false)}>
                <span className="path-slash">./</span>hackathons
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                href={resumePdf}
                target="_blank"
                rel="noreferrer"
                onClick={() => updateExpanded(false)}
              >
                <span className="path-slash">./</span>resume
              </Nav.Link>
            </Nav.Item>
          </Nav>

          {/* Right Section: GitHub Fork / Star Button */}
          <div className="navbar-right-github">
            <Button
              href="https://github.com/Khushbu-github/Portfolio"
              target="_blank"
              className="fork-btn-inner"
            >
              <CgGitFork style={{ fontSize: "1.05em" }} />{" "}
              <AiFillStar style={{ fontSize: "1.05em" }} />
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
